import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import PhotoSwipe from "photoswipe";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import Flickity from "flickity";
const HTML = document.querySelector("html");
const OVERLAY = document.querySelector(".overlay-main");
class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == void 0) {
          const figure = $el.closest("figure");
          if (figure)
            figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure)
          figure.classList.add("img-is-loaded");
      },
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      }
    });
    OVERLAY.addEventListener("click", (e) => {
      e.preventDefault();
      window.dispatchEvent(new Event("close.all"));
    });
    const triggers = document.querySelectorAll(".trigger-search");
    if (triggers) {
      const input = document.querySelector("#s");
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          HTML.classList.toggle("open-search");
          if (input) {
            setTimeout(() => {
              input.focus();
            }, 100);
          }
        });
      });
      HTML.addEventListener("click", (e) => {
        if (HTML.classList.contains("open-search") && !e.target.closest(".form-search") && !e.target.classList.contains("form-search")) {
          HTML.classList.remove("open-search");
        }
      });
    }
    this.menu();
    this.lightbox();
    this.category();
    this.account();
    this.sidebar();
    this.pushGammes();
    this.inViewport();
    this.form();
    this.tabs();
    this.slider();
    this.sticky();
  }
  account() {
    const nav = document.querySelectorAll(".account-navigation select");
    if (nav)
      nav.forEach((select) => {
        select.addEventListener("change", (e) => {
          window.location.href = e.target.value;
        });
      });
  }
  category() {
    const triggers = document.querySelectorAll(".trigger-categories");
    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-categories");
        });
      });
    }
  }
  menu() {
    const mainNavs = document.querySelectorAll(".main-nav .has-submenu > a");
    if (mainNavs) {
      mainNavs.forEach((trigger) => {
        const parent = trigger.closest("li");
        const close = parent.querySelectorAll("h3");
        trigger.addEventListener("click", (e) => {
          if (window.innerWidth < 1280) {
            e.preventDefault();
            parent.classList.toggle("open");
          }
        });
        if (close) {
          close.forEach((c) => {
            c.addEventListener("click", (e) => {
              if (window.innerWidth < 1280) {
                e.preventDefault();
                parent.classList.remove("open");
              }
            });
          });
        }
      });
    }
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
          if (!HTML.classList.contains("open-menu") && mainNavs) {
            mainNavs.forEach((nav) => {
              nav.closest("li").classList.remove("open");
            });
          }
        });
      });
    }
  }
  lightbox() {
    const lightboxes = document.querySelectorAll(".lightbox");
    if (lightboxes) {
      lightboxes.forEach((el) => {
        const gallery = el.querySelector(".gallery");
        const mainImg = el.querySelector(".thumbnail-main");
        const lightbox = new PhotoSwipeLightbox({
          gallery,
          children: "a",
          pswpModule: () => PhotoSwipe
        });
        lightbox.init();
        lightbox.on("openingAnimationEnd", () => {
          if (lightbox.options.dataSource.items) {
            const srcs = [];
            const items = [];
            lightbox.options.dataSource.items.forEach((item) => {
              if (!srcs.includes(item.href)) {
                items.push(item);
                srcs.push(item.href);
              }
            });
            lightbox.options.dataSource.items = items;
          }
        });
        const thumbnails = el.querySelectorAll(".gallery-thumbnails a");
        if (thumbnails && mainImg) {
          thumbnails.forEach((thumb) => {
            thumb.addEventListener("click", (e) => {
              e.preventDefault();
              if (thumb.classList.contains("active"))
                return false;
              const img = new Image();
              img.src = thumb.href;
              mainImg.href = thumb.dataset.zoom;
              mainImg.dataset.pswpWidth = thumb.dataset.pswpWidth;
              mainImg.dataset.pswpHeight = thumb.dataset.pswpHeight;
              mainImg.querySelector("img").src = thumb.querySelector("img").src;
              img.addEventListener("load", function() {
                mainImg.querySelector("img").src = thumb.href;
              });
              const active = el.querySelector(".gallery-thumbnails a.active");
              if (active)
                active.classList.remove("active");
              thumb.classList.add("active");
            });
          });
        }
      });
    }
  }
  inViewport() {
    inView.offset(window.innerHeight * 0.1);
    inView(".js-reveal:not(.is-visible)").on("enter", function(elt) {
      elt.dispatchEvent(new Event("inview"));
      elt.classList.add("is-visible");
      elt.classList.remove("not-visible");
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay != "" && elt.dataset.autoplay != void 0 || video && video.dataset.autoplay != "" && video.dataset.autoplay != void 0) {
        const v = video || elt;
        v.play();
      }
    }).on("exit", function(elt) {
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay != "" && elt.dataset.autoplay != void 0 || video && video.dataset.autoplay != "" && video.dataset.autoplay != void 0) {
        const v = video || elt;
        v.pause();
      }
      elt.dispatchEvent(new Event("outview"));
      elt.classList.add("not-visible");
    });
  }
  sidebar() {
    const triggers = document.querySelectorAll("[data-sidebar]");
    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          const target = document.querySelector(`#${trigger.dataset.sidebar}`);
          if (target) {
            let closeSidebar = function(ev) {
              ev.preventDefault();
              HTML.classList.remove("open-sidebar");
              gsap.to(target, { duration: 0.4, x: "100%", ease: "circ.inOut" });
            };
            HTML.classList.add("open-sidebar");
            gsap.to(target, { duration: 0.4, x: "0%", ease: "circ.inOut" });
            const close = target.querySelector(".trigger-close");
            if (close) {
              close.removeEventListener("click", closeSidebar);
              window.removeEventListener("close.all", closeSidebar);
              close.addEventListener("click", closeSidebar);
              window.addEventListener("close.all", closeSidebar);
            }
          }
        });
      });
    }
  }
  pushGammes() {
    const containers = document.querySelectorAll(".push-gammes");
    if (containers) {
      containers.forEach((container) => {
        const triggers = container.querySelectorAll("a[data-cat]");
        const gridOverlay = container.querySelector(".grid-overlay");
        if (triggers) {
          triggers.forEach((trigger) => {
            trigger.addEventListener("mouseenter", () => {
              const figure = container.querySelector(`figure[data-cat="${trigger.dataset.cat}"]`);
              if (figure) {
                gsap.fromTo(figure, { scale: 1.1, autoAlpha: 0, zIndex: 2 }, { duration: 0.7, autoAlpha: 1, scale: 1, ease: "expo.out" });
                gsap.to(gridOverlay, {
                  opacity: 0.2,
                  duration: 0.4
                });
              }
            });
            trigger.addEventListener("mouseleave", () => {
              const figure = container.querySelector(`figure[data-cat="${trigger.dataset.cat}"]`);
              gsap.to(gridOverlay, {
                opacity: 1,
                duration: 0.4
              });
              if (figure) {
                gsap.to(figure, { duration: 0.3, autoAlpha: 0, zIndex: 1 });
              }
            });
          });
          window.addEventListener("scroll", () => {
            gsap.to(container.querySelectorAll("figure"), {
              duration: 0.3,
              autoAlpha: 0,
              zIndex: 1
            });
          });
        }
      });
    }
  }
  tabs() {
    const elts = document.querySelectorAll(".tabs");
    if (elts) {
      elts.forEach((tabs) => {
        const triggers = tabs.querySelectorAll(".tabs-header a");
        const container = tabs.querySelector(".tabs-container");
        const items = tabs.querySelectorAll(".tabs-item");
        let current = -1;
        if (items && triggers) {
          let goto = function(index) {
            if (current >= 0) {
              items[current].classList.remove("active");
              triggers[current].classList.remove("active");
              gsap.to(items[current], { duration: 0.3, autoAlpha: 0 });
            }
            gsap.to(container, {
              duration: 0.3,
              height: items[index].children[0].offsetHeight,
              delay: 0.2
            });
            gsap.fromTo(items[index], { autoAlpha: 0, y: "2rem" }, { duration: 0.3, autoAlpha: 1, y: "0rem", delay: 0.2 });
            triggers[index].classList.add("active");
            current = index;
          };
          items.forEach((item, i) => {
            if (item.classList.contains("active")) {
              current = i;
            }
          });
          if (current >= 0) {
            gsap.set(container, {
              height: items[current].children[0].offsetHeight
            });
            items[current].classList.remove("active");
            gsap.set(items[current], { autoAlpha: 1 });
          }
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              if (trigger.classList.contains("active"))
                return false;
              goto(i);
            });
          });
        }
      });
    }
  }
  slider() {
    const sliders = document.querySelectorAll(".slider");
    if (sliders) {
      sliders.forEach((slider) => {
        const bar = slider.querySelector(".bar");
        new Flickity(slider, {
          prevNextButtons: false,
          pageDots: false,
          watchCSS: true,
          cellSelector: ".item",
          on: {
            scroll(progress) {
              const p = (this.selectedIndex + 1) / this.cells.length;
              if (bar)
                gsap.to(bar, {
                  width: `${p * 100}%`
                });
            }
          }
        });
      });
    }
  }
  form() {
    const quantity = document.querySelectorAll(".quantity");
    if (quantity) {
      quantity.forEach((qty) => {
        const btns = qty.querySelectorAll("a.less, a.more");
        const input = qty.querySelector(".qty");
        if (btns && input) {
          btns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              const nb = Number.parseInt(input.value);
              if (btn.classList.contains("less")) {
                input.value = nb <= input.min ? input.min : nb - 1;
              } else {
                input.value = input.max && nb >= input.max ? input.max : nb + 1;
              }
              jQuery(input).trigger("change");
              const updateBtn = document.querySelector('[name="update_cart"]');
              if (updateBtn) {
                jQuery(updateBtn).trigger("click");
              }
            });
          });
        }
      });
    }
  }
  sticky() {
    const stickys = document.querySelectorAll("[data-sticky]");
    if (stickys) {
      if (window.innerWidth < 1024)
        return false;
      stickys.forEach((el) => {
        const parent = el.dataset.stickyContainer ? document.querySelector(el.dataset.stickyContainer) : el.parentElement;
        window.addEventListener("resize", (e) => {
          window.dispatchEvent(new Event("scroll"));
        });
        window.addEventListener("scroll", (e) => {
          const pos = el.getBoundingClientRect();
          const pPos = parent.getBoundingClientRect();
          const offset = el.dataset.stickyOffset ? document.querySelector(el.dataset.stickyOffset).offsetHeight : 0;
          const container = el.dataset.stickyContainer ? document.querySelector(el.dataset.stickyContainer) : false;
          const containerPos = container ? container.getBoundingClientRect() : 0;
          if (pPos.height > pos.height) {
            if (pPos.top - offset <= 0) {
              el.style.width = `${el.parentElement.offsetWidth}px`;
              if (container && containerPos.bottom - pos.height - offset <= 0) {
                el.style.position = "absolute";
                el.style.top = `auto`;
                el.style.bottom = `0px`;
                el.style.left = `0px`;
              } else {
                el.style.position = "fixed";
                el.style.top = `${offset}px`;
                el.style.bottom = `auto`;
                el.style.left = `${pPos.x}px`;
              }
            } else {
              el.style.position = "absolute";
              el.style.top = `0px`;
              el.style.bottom = `auto`;
              el.style.left = `0px`;
              el.style.width = `100%`;
            }
          }
        });
        window.dispatchEvent(new Event("scroll"));
      });
    }
  }
}
window.addEventListener("load", () => {
  new App();
});


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
